'use strict';

import Loader from '../loader/loader';
import '../../_assets/abbott/js/_modernizr';
import { isFieldEmpty, isValidEmail, displayErrors } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';
import Handlebars from 'handlebars';
import moment from 'moment';

export default class TenderPriceManagement {
    constructor() {
        let $body = $('body'),
            $tenderPriceManagement = $('.tender-pricing-management');
        if($tenderPriceManagement.length == 0) return; 

        
        let $editTenderDropdown = $('.tender__dropdown'),
            $editPricingDropDown = $(".tender_priceupdate_dropdown"),
            $editExpiryDropDown = $(".tender_priceexpiry_dropdown"),
            $editNewPriceDropdown = $(".tender_newprice_dropdown"),
            $editExpiryBulkDropDown = $(".tender_bulkexpiry_dropdown"),
            templateTenderPriceRow = $("#tmpTenderProductRow").html(),
            $tableBodyProducts = $(".tender-products-body"),
            $fieldTenderName = $("#TenderName"),
            $fieldTenderStartDate = $("#TenderStartDate"),
            $fieldTenderEndDate = $("#TenderEndDate"),
            $tableProducts = $("#table-tender-management-products"),
            $tableInstitutions = $("#table-tender-institutions"),
            $tableTenderPricings = $("#table-sort-tender-pricing"),
            $btnBulkExtend = $(".bulk-action"),
            $tableTenderDelivery = $("#table-tender-delivery"),
            templateTenderDeliveryRow = $("#tmpTenderDeliveryRow").html(),
            $FilterByStatus = $("#FilterByStatus"),
            $FilterByTender = $("#FilterByTender"),
            $FilterBySku = $("#FilterBySku"),
            $pnlMixedFlavour = $(".panel-mixed-flavour"),
            $pnlSettings = $(".settings-panel"),

            $fieldUpdatePricingTenderName = $("#UpdatePricingTenderName"),
            $fieldUpdatePricingProduct = $("#UpdatePricingProduct"),
            $fieldUpdatePricingProductId = $("#UpdatePricingProductId"),
            $fieldUpdatePricingTenderId = $("#UpdatePricingTenderId"),
            $fieldUpdatePricingCurrentPrice = $("#UpdatePricingCurrentPrice"),
            $fieldUpdatePricingCurrentExpiryDate = $("#UpdatePricingCurrentExpiryDate"),
            $fieldUpdatePricingCurrentStartDate = $("#UpdatePricingCurrentStartDate"),
            $fieldUpdatePricingPrice = $("#UpdatePrice"),
            $fieldUpdatePricingPrice42 = $("#UpdatePrice42"),
            $fieldUpdatePricingPriceSingleUnit = $("#UpdatePriceSingleUnit"),
            $fieldUpdatePricingStartDate = $("#UpdatePricingStartDate"),
            $fieldUpdatePricingExpiryDate = $("#UpdatePricingExpiryDate"),
            $fieldUpdatePricingId = $("#UpdatePricingId"),
            
            $fieldUpdateExpiryTenderName = $("#UpdateExpiryTenderName"),
            $fieldUpdateExpiryProduct = $("#UpdateExpiryProduct"),
            $fieldUpdateExpiryCurrentPrice = $("#UpdateExpiryCurrentPrice"),
            $fieldUpdateExpiryDate = $("#UpdateExpiryDate"),
            $fieldUpdateExpiryCurrentStart = $("#UpdateExpiryCurrentStart"),
            $fieldUpdateExpiryCurrentExpiry = $("#UpdateExpiryCurrentExpiry"),
            $fieldUpdateExpiryId = $("#UpdateExpiryId"),
            $fieldUpdateExpiryProductId = $("#UpdateExpiryProductId"),
            $fieldUpdateExpiryTenderId = $("#UpdateExpiryTenderId"),
            $fieldUpdateExpiryAll = $("#UpdateAllActivePricingExpiry"),

            $fieldNewPriceProduct = $("#NewPriceProduct"),
            $fieldNewPriceStartDate = $("#NewPriceStartDate"),
            $fieldNewPriceEndDate = $("#NewPriceEndDate"),
            $fieldNewPrice = $("#NewProductPrice"),
            $fieldNewPrice42 = $("#NewProductPrice42"),
            $fieldNewPriceSingleUnit = $("#NewProductPriceSingleUnit"),
            $tblBodyNewPriceTenders = $(".new-price-tenders-body"),
            $hdnTendersJson = $("#TendersJson"),
            tenderArray = [],
            apiUrl = '/api/tenders/filterprices',
            filterValTenderId = null,
            filterValSku = null,
            filterValStatus = "Active",

            $fieldDeliveryCostType = $("#DeliveryCostType"),
            $fieldQuantityType = $("#QuantityType"),
            $fieldDeliveryCost = $("#DeliveryCost"),
            $fieldFreeDeliveryThreshold = $("#FreeDeliveryThreshold"),
            $fieldSettingsStartDate = $("#SettingsStartDate"),
            $fieldSettingsEndDate = $("#SettingsEndDate"),
            $fieldSettingsGraceDate = $("#SettingsGraceDate"),

            $fieldTenderSettingId = $("#TenderSettingId"),
            $fieldUpdateDeliveryCostType = $("#UpdateDeliveryCostType"),
            $fieldUpdateQuantityType = $("#UpdateQuantityType"),
            $fieldUpdateDeliveryCost = $("#UpdateDeliveryCost"),
            $fieldUpdateFreeDeliveryThreshold = $("#UpdateFreeDeliveryThreshold"),
            $fieldUpdateSettingsStartDate = $("#UpdateSettingsStartDate"),
            $fieldUpdateSettingsEndDate = $("#UpdateSettingsEndDate"),
            $fieldUpdateSettingsGraceDate = $("#UpdateSettingsGraceDate"),

            loader = new Loader();

        try {
            tenderArray = JSON.parse($hdnTendersJson.val());
        }catch(ex){
            console.log(ex);
        }

        let getTenderName = function(tenderId){
            let tender = tenderArray.find(t=>t.Id == tenderId);
            if(tender != null){
                return tender.Name;
            }
            return "";
        }

        let clearFormValidation = function($btn) {
            $btn.parents("form").find(".incomplete").removeClass(".incomplete");
        }
        
        let drawPricingTable = function() {
        //Table: Tender pricing displayed on pricing management page
            if($tableTenderPricings.length){
                let apiUrl = '/api/tenders/filterprices';
                let queryString = [];
                if(filterValTenderId != '') {
                    queryString.push(`tenderId=${filterValTenderId}`);
                }
                if(filterValSku != '') {
                    queryString.push(`sku=${filterValSku}`);
                }
                if(filterValStatus != '') {
                    queryString.push(`status=${filterValStatus}`);
                }
                $tableTenderPricings.
                    on( 'error.dt', function ( e, settings, techNote, message ) {
                        console.log( 'An error has been reported by DataTables: ', message );
                    })
                    .on( 'init.dt', function () {
                        let dtPricings = $tableTenderPricings.DataTable();
                        dtPricings.columns(".pricing-status").search("active").draw();
                    })
                    .DataTable({
                        ordering: true,
                        processing: true,
                        pageLength: 50,
                        dom: '<"">frtip',
                        order: [[ 11, 'desc' ]],
                        // columnDefs: [
                        //     { targets: [9], searchable: false, orderable: false},
                        //     { targets: [10], visible: false},
                        // ]
                    });
            }
        };

        drawPricingTable();

        Handlebars.registerHelper("formatDate", function(options) {
            return moment(options).format("DD-MM-YYYY");
        });
        Handlebars.registerHelper("formatDateTime", function(options) {
            return moment(options).format("DD-MM-YYYY HH:mm");
        });
        Handlebars.registerHelper("formatDateAussie", function(options) {
            return moment(options+'Z').local().format("DD-MM-YYYY");
        });
        Handlebars.registerHelper("centsToDollars", function(options) {
            if(options == "" || options == null) {
                return "NA";
            }
            return `$${(Number.parseInt(options) / 100).toFixed(2)}`;
        });
        Handlebars.registerHelper("arrayToCsv", function(options) {
            if(options == "" || options == null || options.length == 0) {
                return "";
            }
            return options.join(",");
        });


        $fieldDeliveryCostType.on("change", function(e){
            let $elem = $(this);
            let selectedItem = $elem.val();
            if(selectedItem === "Flat"){//flat
                $(".dc-state-based").removeClass("show");
                $(".dc-settings-based").addClass("show");
            } else {
                $(".dc-state-based").addClass("show");
                $(".dc-settings-based").removeClass("show");
            }
        });

        $(".js-new-tender").on("click", function(e){
            e.preventDefault();
            clearFormValidation($(this));
            $editTenderDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
            $fieldTenderName.val("");
            $fieldTenderStartDate.val("");
            $fieldTenderEndDate.val("");
            $fieldDeliveryCost.val("");
            $fieldDeliveryCostType.val("");
            $fieldFreeDeliveryThreshold.val("");
            $fieldQuantityType.val("");
            $fieldSettingsStartDate .val("");
            $fieldSettingsEndDate.val("");
            $fieldSettingsGraceDate.val("");
        });

        $(".js-new-tender-pricing").on("click", function(e){
            e.preventDefault();
            clearFormValidation($(this));
            $editNewPriceDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
            $fieldNewPrice.val("");
            $fieldNewPrice42.val("");
            $fieldNewPriceSingleUnit.val("");
            $fieldNewPriceEndDate.val("");
            $fieldNewPriceStartDate.val("");
            $fieldNewPriceProduct.val("");
        });

        $(document).on("change", ".chk-price", function(e){
            // e.preventDefault();
            let $chk = $(this);
            let $tr = $chk.parents("tr");
            $tr.removeClass("selected");
            if($chk.prop("checked")) {
                $tr.addClass("selected");
            }
            // toggleBulkAction();
        });

        $(".chk-price-all").on("change", function(e){
            // e.preventDefault();
            let $table = $(this).parents("table");
            let $allRows = [];
            if($.fn.DataTable.isDataTable($table)) {
                $allRows = $table.DataTable().rows().nodes().to$();
            } else {
                $allRows = $table.find("tbody tr");
            }
            $allRows.find(".chk-price").prop("checked",$(this).prop("checked")).trigger('change');
            // toggleBulkAction();
        });

        let getTenderFormData = function(){
            return {
                Name: $fieldTenderName.val(),
                StartDate: moment($fieldTenderStartDate.val(), "DD-MM-YYYY").toDate(),
                ExpiryDate: moment($fieldTenderEndDate.val(), "DD-MM-YYYY").toDate(),
                Pricings: [],
                DeliveryCosts: [],
                Institutions: []
            };
        }

        let toggleBulkAction = function(){
            $btnBulkExtend.removeClass("visible");
            if($tableTenderPricings.DataTable().rows(".selected").nodes().length > 0) {
                $btnBulkExtend.addClass("visible");
            }
        }

        let getValueFromFilter = function($filterElem) {
            let searchTerm = $filterElem.find(".filter-dropdown--selected").attr("data-value");
            if(searchTerm.toLowerCase() == "all") {
                searchTerm = "";
            }
            return searchTerm;
        }

        let toggleMixedFlavour = function($prodElement) {
            $pnlMixedFlavour.removeClass("show");
            let isMixedFlavour = $prodElement.find("option:selected").data("ismixedflavour");
            if(isMixedFlavour){
                $pnlMixedFlavour.addClass("show");
            }
        }

        $FilterBySku.on("keyup", function(e){
            let sku = $(this).val();
            let dtPricings = $tableTenderPricings.DataTable();
            dtPricings.search(sku).draw();
        });

        $FilterByStatus.find('.filter-dropdown--item').on("click", function(e){
            let status = getValueFromFilter($FilterByStatus);
            let dtPricings = $tableTenderPricings.DataTable();
            dtPricings.columns(".pricing-status").search(status).draw();
        })

        $FilterByTender.find('.filter-dropdown--item').on("click", function(e){
            let tenderId = getValueFromFilter($FilterByTender);
            let dtPricings = $tableTenderPricings.DataTable();
            dtPricings.columns(".tender-name").search(tenderId).draw();
        });
        
        $fieldNewPriceProduct.on("change", function(e){
            let prodId = $(this).val();
            let filterData = getPricingFilterData("", prodId, "");
            loader.fadeIn();
            $.ajax({
                url: '/api/tenders/getpricings',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'POST',
                headers: { __RequestVerificationToken: $editNewPriceDropdown.find('input[name=__RequestVerificationToken]').val() },
                data: JSON.stringify(filterData),
                success: function (result) {
                    loader.fadeOut();
                    let rowTemplateHtml = $("#tmpNewPriceTenderRow").html();
                    let rowTemplate = Handlebars.compile(rowTemplateHtml);
                    let htmlRows = [];
                    $tblBodyNewPriceTenders.html(`<tr><td colspan="2">${$fieldNewPriceProduct.find("option:selected").text()} already has active pricing for all current tenders. Please search for the SKU and update/expire pricing instead of adding a new product pricing.</td></tr>`);
                    let tendersList = [];
                    tenderArray.forEach(element => {
                        let tenderPrice = result.find(x=>x.TenderId == element.Id);
                        if(tenderPrice == null) {
                            if(tendersList.indexOf(element.Name) == -1) {
                                tendersList.push(element.Name);
                                htmlRows.push(rowTemplate(element));
                            }
                        }
                    });
                    if(htmlRows.length > 0) {
                        $tblBodyNewPriceTenders.html(htmlRows.join(""));
                    }
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });
        })

        $(document).on("click", ".js-price-update", function(e){
            e.preventDefault();
            clearFormValidation($(this));
            $editPricingDropDown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
            let priceJson = JSON.parse($(this).parents(".js-price-actions").find(".hidden-price-json").val());
            $fieldUpdatePricingProduct.val(`${priceJson.Product.Brand} ${priceJson.Product.Flavour} ${priceJson.Product.PackagingType} - ${priceJson.Product.Sku}`);
            $fieldUpdatePricingTenderName.val($(this).data("tender-name"));
            $fieldUpdatePricingCurrentPrice.val(priceJson.ModifiedPrice / 100);
            $fieldUpdatePricingCurrentStartDate.val(moment.utc(priceJson.CommencementDate).local().format('DD-MM-YYYY'));
            $fieldUpdatePricingCurrentExpiryDate.val(moment.utc(priceJson.ExpiryDate).format('DD-MM-YYYY'));
            $fieldUpdatePricingProductId.val(priceJson.ProductId);
            $fieldUpdatePricingTenderId.val(priceJson.TenderId);
            $fieldUpdatePricingId.val(priceJson.Id);
            $fieldUpdatePricingPrice.val("");
            $fieldUpdatePricingPrice42.val("");
            $fieldUpdatePricingPriceSingleUnit.val("");
            $fieldUpdatePricingStartDate.val("");
            $fieldUpdatePricingExpiryDate.val("");
        });

        $(document).on("click", ".js-expiry-update", function(e){
            e.preventDefault();
            clearFormValidation($(this));
            $editExpiryDropDown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
            let priceJson = JSON.parse($(this).parents(".js-price-actions").find(".hidden-price-json").val());
            $fieldUpdateExpiryProduct.val(`${priceJson.Product.Brand} ${priceJson.Product.Flavour} ${priceJson.Product.PackagingType} - ${priceJson.Product.Sku}`);
            $fieldUpdateExpiryTenderName.val($(this).data("tender-name"));
            $fieldUpdateExpiryCurrentPrice.val(priceJson.ModifiedPrice / 100);
            $fieldUpdateExpiryCurrentStart.val(moment.utc(priceJson.CommencementDate).local().format('DD-MM-YYYY'));
            $fieldUpdateExpiryCurrentExpiry.val(moment.utc(priceJson.ExpiryDate).format('DD-MM-YYYY'));
            $fieldUpdateExpiryProductId.val(priceJson.ProductId);
            $fieldUpdateExpiryTenderId.val(priceJson.TenderId);
            $fieldUpdateExpiryId.val(priceJson.Id);
            let $warnings = $(".active-regimens-warnings");
            $warnings.html("");
            if(priceJson.ActiveRegimens.length > 0) {
                $warnings.html(`Note: There are ${priceJson.ActiveRegimens.length} active nutrition plan(s). Expiring this pricing without having another active pricing scheduled immediately will cancel these nutrition plan(s): ${priceJson.ActiveRegimens.join(",")}`);
            }
            $fieldUpdateExpiryDate.val("");
        });

        $(document).on("click", ".js-tender-price-add", function(e){
            clearFormValidation($(this));
            let tenderPriceTemplate = Handlebars.compile(templateTenderPriceRow);
            let formData = getTenderFormData();
            formData.Id = $tableProducts.DataTable().column(0).data().length + 1;
            let $rowHtml = $(tenderPriceTemplate(formData));
            $tableProducts.DataTable().row.add($rowHtml).draw();
            // $tableBodyProducts.append($rowHtml);
            $rowHtml.find('.native').materialize();
            $rowHtml.find('.datepicker').pickadate({
                format: 'dd-mm-yyyy'
            });
            $rowHtml.find(".tender-product").on("change", function(pe){
                $rowHtml.find(".tender-product-price").html($(this).find("option:selected").data("price"));
            });
            var existingPricings = getNewTenderProducts();
            let $newProduct = $rowHtml.find(".tender-product");
            existingPricings.forEach(p=>{
                $newProduct.find("option").each((idx, itm)=>{
                    if($(itm).attr("value") == p.ProductId) {
                        $(itm).remove();
                    }
                });
            });
            $newProduct.val("");
        });

        $(document).on("click", ".js-remove-pricing", function(e){
            e.preventDefault();
            clearFormValidation($(this));
            $tableProducts.DataTable().rows($(this).parents("tr")).remove().draw();
        });

        let getPricingFilterData = function(tenderName, productSkuOrId, productStatus){
            return {
                Sku: productSkuOrId,
                TenderName: tenderName,
                Status: productStatus
            };
        }

        let getExpiryUpdateData = function(){
            return {
                PricingId: $fieldUpdateExpiryId.val(),
                ExpiryDate: moment($fieldUpdateExpiryDate.val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                CurrentExpiryDate: $fieldUpdateExpiryCurrentExpiry.val(),
                ProductId: $fieldUpdateExpiryProductId.val(),
                TenderId: $fieldUpdateExpiryTenderId.val(),
                UpdateAll: $fieldUpdateExpiryAll.prop("checked")
            };
        }

        let getPricingUpdateData = function(){
            return {
                PricingId: $fieldUpdatePricingId.val(),
                StartDate: moment($fieldUpdatePricingStartDate.val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                ExpiryDate: moment($fieldUpdatePricingExpiryDate.val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                CurrentExpiryDate: moment($fieldUpdateExpiryCurrentExpiry.val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                CurrentStartDate: moment($fieldUpdateExpiryCurrentExpiry.val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                Price: $fieldUpdatePricingPrice.val(),
                SpecialPrice: $fieldUpdatePricingPrice42.val(),
                SingleUnitPrice: $fieldUpdatePricingPriceSingleUnit.val(),
                ProductId: $fieldUpdatePricingProductId.val(),
                TenderId: $fieldUpdatePricingTenderId.val(),
            };
        }

        let getNewPricingData = function(){
            return {
                PricingId: $fieldUpdatePricingId.val(),
                StartDate: moment($fieldNewPriceStartDate.val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                ExpiryDate: moment($fieldNewPriceEndDate.val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                Price: $fieldNewPrice.val(),
                SpecialPrice: $fieldNewPrice42.val(),
                SingleUnitPrice: $fieldNewPriceSingleUnit.val(),
                ProductId: $fieldNewPriceProduct.val(),
            };
        }

        let validateNewPricingForm = function($btn){
            let _isInvalid = [];
            $btn.parents("form").find(".error").slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
            $btn.parents("form").find(".incomplete").removeClass(".incomplete");
            if (isFieldEmpty($fieldNewPriceProduct)) {
                $fieldNewPriceProduct
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldNewPriceProduct);
            }

            if (isFieldEmpty($fieldNewPriceStartDate)) {
                $fieldNewPriceStartDate
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldNewPriceStartDate);
            }

            if (isFieldEmpty($fieldNewPriceEndDate)) {
                $fieldNewPriceEndDate
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldNewPriceEndDate);
            }

            if (isFieldEmpty($fieldNewPrice)) {
                $fieldNewPrice
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldNewPrice);
            }

            if (_isInvalid.length > 0) {
                $btn.addClass('error');
                _isInvalid[0].focus();
                return false;
            } else {
                $btn.removeClass('error');
                return true;
            }
        }


        let validatePricingForm = function($btn){
            let _isInvalid = [];

            $btn.parents("form").find(".error").slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
            $btn.parents("form").find(".incomplete").removeClass(".incomplete");
            if (isFieldEmpty($fieldUpdatePricingPrice)) {
                $fieldUpdatePricingPrice
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldUpdatePricingPrice);
            }

            if (isFieldEmpty($fieldUpdatePricingStartDate)) {
                $fieldUpdatePricingStartDate
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldUpdatePricingStartDate);
            }

            if (isFieldEmpty($fieldUpdatePricingExpiryDate)) {
                $fieldUpdatePricingExpiryDate
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldUpdatePricingExpiryDate);
            }

            if (_isInvalid.length > 0) {
                $btn.addClass('error');
                return false;
            } else {
                $btn.removeClass('error');
                return true;
            }
        }

        let validateExpiryForm = function($btn){
            let _isInvalid = [];

            $btn.parents("form").find(".error").slideUp({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });
            $btn.parents("form").find(".incomplete").removeClass(".incomplete");
            if (isFieldEmpty($fieldUpdateExpiryDate)) {
                $fieldUpdateExpiryDate
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push($fieldUpdatePricingPrice);
            }

            if (_isInvalid.length > 0) {
                $btn.addClass('error');
                return false;
            } else {
                $btn.removeClass('error');
                return true;
            }
        }

        $(".js-save-new-pricing").on("click", function(e){
            e.preventDefault();
            let $btn = $(this);
            if(validateNewPricingForm($btn)) {
                let pricingData = getNewPricingData();

                let tenders = $tblBodyNewPriceTenders.find("tr[data-tender-id]").map(function(idx, elem){
                    let $elem = $(elem);
                    if($elem.find(".chk-price").prop("checked")) {
                        return $elem.data("tender-id");
                    } else {
                        return null;
                    }
                }).toArray().filter(x=>x != null);

                if(tenders.length == 0){
                    toaster("At least one tender must be selected.", "error");
                    return;
                }

                pricingData.TenderIds = tenders;

                loader.fadeIn();
                
                // Define where to display ajax errors
                let $errorContainer = $btn.parent().siblings('.server-errors__wrap');

                $.ajax({
                    url: '/api/tenders/createnewpricing',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST',
                    headers: { __RequestVerificationToken: $editNewPriceDropdown.find('input[name=__RequestVerificationToken]').val() },
                    data: JSON.stringify(pricingData),
                    success: function (data) {
                        toaster('Pricing has been saved!');
                        // window.location.href = data.href;
                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        $editNewPriceDropdown.find('.js-collapse-form-modal').trigger('click');
                        
                        let priceRowHtml = $("#tmpPricingRow").html();
                        let tenderPriceTemplate = Handlebars.compile(priceRowHtml);
                        data.forEach(itm=>{
                            itm.TenderName = getTenderName(itm.TenderId);
                            itm.Json = JSON.stringify(itm);
                            let $rowHtml = $(tenderPriceTemplate(itm));
                            $tableTenderPricings.DataTable().row.add($rowHtml).draw();
                            $rowHtml.addClass("updated");
                        });   
                        $tableTenderPricings.DataTable().columns(".date-modified").order('desc').draw();
                    },
                    error: function (error) {
                        loader.fadeOut();
                        displayErrors(error, $errorContainer );
                    }
                });
            }
        });

        $(".js-save-pricing").on("click", function(e){
            e.preventDefault();
            let $btn = $(this);
            if(validatePricingForm($btn)) {
                let pricingData = getPricingUpdateData();
                loader.fadeIn();
                
                // Define where to display ajax errors
                let $errorContainer = $btn.parent().siblings('.server-errors__wrap');

                $.ajax({
                    url: '/api/tenders/updatepricing',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST',
                    headers: { __RequestVerificationToken: $editPricingDropDown.find('input[name=__RequestVerificationToken]').val() },
                    data: JSON.stringify(pricingData),
                    success: function (data) {
                        toaster('Pricing has been saved!');
                        loader.fadeOut();
                        
                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });
                        $editPricingDropDown.find('.js-collapse-form-modal').trigger('click');

                        let $currentRow = $tableTenderPricings.find("tr[data-id='"+pricingData.PricingId+"']");
                        $tableTenderPricings.DataTable().row($currentRow).remove().draw();

                        let priceRowHtml = $("#tmpPricingRow").html();
                        let tenderPriceTemplate = Handlebars.compile(priceRowHtml);
                        data.forEach(itm=>{
                            itm.TenderName = getTenderName(itm.TenderId);
                            itm.Json = JSON.stringify(itm);
                            let $rowHtml = $(tenderPriceTemplate(itm));
                            $rowHtml.addClass("updated");
                            $tableTenderPricings.DataTable().row.add($rowHtml).draw();
                        });                        
                        $tableTenderPricings.DataTable().columns(".date-modified").order('desc').draw();
                    },
                    error: function (error) {
                        loader.fadeOut();
                        displayErrors(error, $errorContainer );
                    }
                });
            }
        });

        $(".js-save-expiry").on("click", function(e){
            e.preventDefault();
            let $btn = $(this);
            if(validateExpiryForm($btn)) {
                let expiryData = getExpiryUpdateData();
                loader.fadeIn();
                
                // Define where to display ajax errors
                let $errorContainer = $btn.parent().siblings('.server-errors__wrap');

                $.ajax({
                    url: '/api/tenders/updatepricingexpiry',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST',
                    headers: { __RequestVerificationToken: $editExpiryDropDown.find('input[name=__RequestVerificationToken]').val() },
                    data: JSON.stringify(expiryData),
                    success: function (data) {
                        toaster('Pricing expiry has been saved!');
                        // window.location.href = data.href;
                    
                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        $editExpiryDropDown.find('.js-collapse-form-modal').trigger('click');

                        data.TenderName = getTenderName(data.TenderId);
                        data.Json = JSON.stringify(data);
                        let priceRowHtml = $("#tmpPricingRow").html();
                        let tenderPriceTemplate = Handlebars.compile(priceRowHtml);
                        let $rowHtml = $(tenderPriceTemplate(data));
                        let $currentRow = $tableTenderPricings.find("tr[data-id='"+data.Id+"']");
                        $rowHtml.addClass("updated")
                        $tableTenderPricings.DataTable().row($currentRow).remove();
                        $tableTenderPricings.DataTable().row.add($rowHtml).draw();
                        $tableTenderPricings.DataTable().columns(".date-modified").order('desc').draw();
                    },
                    error: function (error) {
                        loader.fadeOut();
                        displayErrors(error, $errorContainer );
                    }
                });
            }
        });

        let getNewTenderProducts = function(validate = false){
            let rows = $tableProducts.DataTable().rows().nodes();
            let isValid = true;
            let tenderPricings = rows.map(function(val, idx){
                let $row = $(val);
                $row.removeClass("invalid");
                let pricingData = {
                    ProductId: $row.find(".tender-product").val(),
                    Price: $row.find(".tender-modified-price").val(),
                    StartDate: moment($row.find(".tender-price-start").val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                    ExpiryDate: moment($row.find(".tender-price-end").val(), "DD-MM-YYYY").format("YYYY-MM-DD"),
                    SpecialPrice: $row.find(".tender-special-price").val(),
                };
                if(validate) {
                    if(pricingData.ProductId == "" || pricingData.ModifiedPrice == "" || pricingData.StartDate == "" || pricingData.EndDate == "") {
                        $row.addClass("invalid");
                        $row.trigger("focus");
                        isValid = false;
                    }
                }
                return pricingData;
            });
            if(validate && !isValid) {
                return false;
            }
            return tenderPricings.toArray();
        }

        let getTenderSettingsData = function(editMode) {
            if(editMode){
                return {
                    Id: $fieldTenderSettingId.val(),
                    DeliveryCostType: $fieldUpdateDeliveryCostType.val(),
                    FlatDeliveryCost: $fieldUpdateDeliveryCost.val(),
                    FreeDeliveryThreshold: $fieldUpdateFreeDeliveryThreshold.val(),
                    CommencementDate: $fieldUpdateSettingsStartDate.val(),
                    ExpiryDate: $fieldUpdateSettingsEndDate.val(),
                    QuantityTypeGraceExpiryDate: $fieldUpdateSettingsGraceDate.val(),
                    QuantityType: $fieldUpdateQuantityType.val()
                }
            } else {
                return {
                    TenderId: $fieldTenderSettingTenderId.val(),
                    DeliveryCostType: $fieldDeliveryCostType.val(),
                    FlatDeliveryCost: $fieldDeliveryCost.val(),
                    FreeDeliveryThreshold: $fieldFreeDeliveryThreshold.val(),
                    CommencementDate: $fieldSettingsStartDate.val(),
                    ExpiryDate: $fieldSettingsEndDate.val(),
                    QuantityTypeGraceExpiryDate: $fieldSettingsGraceDate.val(),
                    QuantityType: $fieldQuantityType.val()
                }
            }
        }

        $(".js-save-tender").on("click", function(e){
            e.preventDefault();
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            let isValid = true,
                tenderData = getTenderFormData(),
                tenderPricings = getNewTenderProducts(true),
                deliveryCostType = $fieldDeliveryCostType.val(),
                tenderSettings = getTenderSettings();

            let deliveryCosts = [];
            if(deliveryCostType == "Flat") {
                
            } else {
                deliveryCostType = $tableTenderDelivery.find("tbody tr").map(function(idx, elem) {
                    let $elem = $(elem);
                    let delCost = {
                        State: $elem.data("state"),
                        FreeFourWeeks: $elem.find(".chk-free-four-weeks").prop("checked"),
                        OneCartonCost: $elem.find(".delivery-cost-1").val(),
                        TwoCartonsCost: $elem.find(".delivery-cost-2").val(),
                        ThreePlusCartonsCost: $elem.find(".delivery-cost-3").val(),
                    };
                    if(delCost.OneCartonCost == "" || delCost.TwoCartonsCost == "" || delCost.ThreePlusCartonsCost == "") {
                        $elem.addClass("invalid");
                        $elem.trigger("focus");
                        isValid = false;
                    }
                    return delCost;
                });
            }

            if(tenderPricings == false || !isValid) {
                toaster('Please esnure all mandatory fields have been completed.', 'error');
                return;
            }

            let institutions = $tableInstitutions.find("tbody tr").map(function(idx, elem){
                let $elem = $(elem);
                return $elem.data("institution-id");
            });

            tenderData.Pricings = tenderPricings;
            tenderData.DeliveryCosts = deliveryCosts.toArray();
            tenderData.Institutions = institutions.toArray();
            
            $.ajax({
                url: '/api/tenders/createnewtender',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'POST',
                headers: { __RequestVerificationToken: $editTenderDropdown.find('input[name=__RequestVerificationToken]').val() },
                data: JSON.stringify(tenderData),
                success: function (data) {
                    toaster('Tender has been saved!');
                    window.setTimeout(()=>{
                        window.location.href = `/tenders/viewtender?id=${data.Id}`;
                    }, 300);
                   
                    loader.fadeOut();

                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });

                    $editTenderDropdown.find('.js-collapse-form-modal').trigger('click');
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });
        });
    }
}
